import { render } from "./BulmaPanelCollapsible.vue?vue&type=template&id=8dbb9ad0&scoped=true"
import script from "./BulmaPanelCollapsible.vue?vue&type=script&lang=js"
export * from "./BulmaPanelCollapsible.vue?vue&type=script&lang=js"

import "./BulmaPanelCollapsible.vue?vue&type=style&index=0&id=8dbb9ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbb9ad0"]])

export default __exports__